/* import __COLOCATED_TEMPLATE__ from './phone-details-fin-search-group.hbs'; */
/* RESPONSIBLE TEAM: team-phone */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import type { ArticleSource } from 'embercom/objects/inbox/call-recording';
import { objectNames } from 'embercom/models/data/matching-system/matching-constants';

export type ResolvedSource = {
  title: string;
  objectName: string | null;
  entityId: string;
};

interface PhoneDetailsFinSearchGroupSignature {
  Args: {
    searchQuery: string;
    sources: ArticleSource[];
    appId?: string;
  };
  Element: HTMLDivElement;
}

export default class PhoneDetailsFinSearchGroup extends Component<PhoneDetailsFinSearchGroupSignature> {
  @tracked isExpanded = false;

  get resolvedSources(): ResolvedSource[] {
    return this.args.sources.map((source) => {
      let entityType = source.entity_type;
      let entityId = source.entity_id;

      // entity_id may be a composite "type-id" string (e.g. "120-2")
      // where the first part is the entity type and the second is the actual id
      if (entityId.includes('-')) {
        let [type, ...rest] = entityId.split('-');
        entityType = parseInt(type, 10);
        entityId = rest.join('-');
      }

      return {
        title: source.title,
        objectName: objectNames[entityType] ?? null,
        entityId,
      };
    });
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::PhoneDetailsFinSearchGroup': typeof PhoneDetailsFinSearchGroup;
    'inbox2/phone-details-fin-search-group': typeof PhoneDetailsFinSearchGroup;
  }
}
